<template>
  <div>
    <van-popup v-model="visible" position="top" :style="{ height: 'auto' }">
      <van-sticky offset-top="0">
        <div class="title" @click="close">title</div>
      </van-sticky>

      <div class="main">
        <div>Time</div>
        <!-- <div>{{ getDateObj() }}</div> -->
        {{ sTimeTip }}
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.remark {
  margin: 0.3rem 0 0.3rem 0;
  line-height: 1.6rem;
}
.title {
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 1.6rem;
  padding: 1rem;
  z-index: 999;
}
.van-popup {
  width: 100%;
  height: 100%;
}
.main {
  padding: 1rem;
  padding-top: 0;
}
</style>

<script>
// import UserNote from "./Child/UserNote.vue";
var fits = require("../../../mixin/lib-fits-front");

export default {
  components: {
    // UserNote,
  },
  data() {
    return {
      visible: false,
      obj: null,
      preview: false,
      itemnote: "",
      anime: false,
    };
  },
  methods: {
    getDateObj() {
      let timeB = fits.unTZ(this.$store.state.sOrderH.FileDate);
      let minute = this.$store.state.sConfig.MaxOrderTime.value;
      let timeE = fits.dateAdd(timeB, minute);
      let span = this.$store.state.sConfig.cSendTime.value;
      let maxQty = this.$store.state.sConfig.maxQty.value;
      let maxItemQty = this.$store.state.sConfig.maxItemQty.value;
      return {
        timeB: timeB,
        minute: minute,
        timeE: timeE,
        span: span,
        maxItemQty: maxItemQty,
        maxQty: maxQty,
      };
    },
    async finish() {
      try {
        if (this.gOverSendTime())
          return this.gMsgbox(this.sGetConfig("txtOverMaxOrderTimeText"));

        if (!this.checkData()) {
          this.gMsgbox("請確認附餐必選項目", "Side Check");
          return;
        }

        this.obj.Groups.map((g) => {
          //如果userNote為空字串，將數量歸0
          g.options.map((o) => {
            console.log("o.ItemName", o.ItemName, o);
            if (o.ItemName == "餐點備註:") o.Qty = 0;
            if (o.ItemName == ":") o.Qty = 0;
          });
        });

        this.gShowLoading();
        var body = { item: this.obj };
        if (this.obj.rno == undefined) {
          await this.apiAddItem(body);
          this.gMsg("加入:" + this.obj.ItemName + "x" + this.obj.Qty);
        } else {
          await this.apiUpdItem(body);
          this.gMsg("更新:" + this.obj.ItemName + "x" + this.obj.Qty);
        }

        this.$emit("callback", this.obj);
        this.close();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
      }
    },
    showDetailGroup(obj) {
      this.$refs.rItemDetailGroup.show(obj);
    },

    onChangePriceCap(priceCap) {
      console.log("onChangePriceCap", JSON.stringify(priceCap));
      this.obj.Price1 = priceCap.Price;
    },
    appendUserNote() {
      let row = {
        id: "userNote",
        text: "",
        type: "A1",
        limit: "0",
        lock: true,
        num: false,
        remark: "",
        options: [
          {
            TypeNo: 4,
            ItemNo: 1,
            ItemName: "",
            ItemType: "-",
            Price1: 0,
            Price2: 0,
            Price3: 0,
            KPtype: this.obj.KPtype,
            OpenCode: "N",
            ImgFile: "",
            ItemCode: "",
            AvailTime: "",
            CtrlFlag: "",
            Price1Cap: "",
            Price2Cap: "",
            Price3Cap: "",
            DispName: "",
            Groups: [],
            Qty: 1,
            DefaultQty: 1,
          },
        ],
        key: fits.uuid(),
      };
      // this.obj.Groups.push(row);
      this.obj.Groups.splice(0, 0, row);
      console.log("obj", JSON.stringify(this.obj));
    },
    async show() {
      try {
        // if (obj.rno) {
        //   this.obj = obj;
        //   return (this.visible = true);
        // }
        // this.gShowLoading();
        // console.log("show timetip");
        // var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
        // var res = await this.apiGetItemC(query);
        // this.obj = res.data;

        // if (this.sGetConfig("userNote")) this.appendUserNote(this.obj);
        // // console.log(JSON.stringify(this.obj));
        this.visible = true;
        // this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    close() {
      this.visible = false;
    },
    // getBtnText() {
    //   this.anime = this.checkData();

    //   if (this.obj.rno) {
    //     return "更新餐點 Update";
    //   }

    //   return "加入" + this.obj.Qty + "份  $" + this.sumItemAmt() + " Add";
    //   // return "加入" +;
    // },
    getBtnText() {
      return "關閉";
    },
    sumItemAmt() {
      var obj = this.obj;
      var rst = this.gGetItemcRst(obj);
      console.log("sumItemAmt", rst[0].Qty, obj.Discount);
      if (rst.length == 0) {
        return 0;
      }
      var s1Qty = rst[0].Qty;
      // console.log("s1Qty", s1Qty);
      rst[0].Qty = 1;
      // console.log("s1", s1Qty);
      rst.map((r) => (r.Amt = r.Price1 * r.Qty));
      var sum = this.gSum(rst, "Amt");
      var doAmt = this.gCalcDcAmt(s1Qty, sum, obj.Discount);
      var original = sum * s1Qty;
      var amt = original + doAmt;
      return { original: original, doAmt: doAmt, amt: amt };
    },
    async cmdDelete() {
      try {
        this.gMsgbox(
          "刪除:" + this.obj.ItemName + "x" + this.obj.Qty,
          "刪除 Remove"
        ).then(async () => {
          this.gShowLoading();
          this.obj.Qty = 0;
          var body = { item: this.obj };
          await this.apiUpdItem(body);
          this.$emit("callback");
          this.close();
          this.gClearLoading();
        });
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },
    checkData() {
      var checked = this.gCheckS1Data(this.obj);
      if (!checked) {
        return false;
      }
      return true;
    },
  },
};
</script>
